'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _UserRow = require('../../shared/UserRow');

var _UserRow2 = _interopRequireDefault(_UserRow);

var _propTypes = require('../../../shared/prop-types');

var spt = _interopRequireWildcard(_propTypes);

var _logValues = require('../../../shared/logging/log-values');

var _hudlBase = require('hudl-base');

var _actionCreators = require('../../../store/actions/action-creators');

var _pagescrollHelper = require('../../../utils/pagescroll-helper');

var _Uniform = require('../../Uniform');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TagDetailsModal = function (_Component) {
  _inherits(TagDetailsModal, _Component);

  function TagDetailsModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TagDetailsModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TagDetailsModal.__proto__ || Object.getPrototypeOf(TagDetailsModal)).call.apply(_ref, [this].concat(args))), _this), _this.onClickProfile = function () {
      var logData = _this.props.logData;

      // UsageLogEvent converts keys to PascalCase

      var usageLogData = {
        func: 'Click',
        op: 'Profile'
      };

      if (logData[_logValues.ORIGIN_KEY]) {
        usageLogData.origin = logData[_logValues.ORIGIN_KEY];
      }

      /* eslint-disable no-new */
      new _hudlBase.UsageLogEvent({
        logger: 'Feed',
        logOnUnload: true,
        data: usageLogData
      });
      /* eslint-enable no-new */
    }, _this.onScrollContent = function () {
      var taggedUsersWrapper = _this.refs.taggedUsersWrapper;
      var scrollTop = taggedUsersWrapper.scrollTop;
      var maxScroll = taggedUsersWrapper.scrollHeight - taggedUsersWrapper.clientHeight;
      var scrollPercentage = scrollTop / maxScroll;
      if (scrollPercentage > 0.80) {
        _this.fetchTaggedUsers();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TagDetailsModal, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.showModal) {
        this.fetchTaggedUsers();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props.showModal || nextProps.showModal;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.showModal === this.props.showModal) {
        return;
      }

      if (this.props.showModal) {
        this.fetchTaggedUsers();
      } else {
        // Defer this to give the modal time to close. This helps prevent
        // jumpiness in Safari.
        setTimeout(_pagescrollHelper.enablePageScroll, 20);
      }
    }
  }, {
    key: 'fetchTaggedUsers',
    value: function fetchTaggedUsers() {
      var dispatch = this.props.dispatch;
      var communityContentIdObject = this.props.communityContentIdObject;
      var communityContentType = communityContentIdObject.type,
          communityContentRelatedId = communityContentIdObject.relatedId;


      dispatch((0, _actionCreators.fetchTagUsersIfNeeded)(communityContentType, communityContentRelatedId));
    }
  }, {
    key: 'getTaggedUsersComponent',
    value: function getTaggedUsersComponent() {
      var _this2 = this;

      var _props = this.props,
          currentUser = _props.currentUserDetails,
          _props$tagDetails = _props.tagDetails,
          tagDetails = _props$tagDetails === undefined ? {} : _props$tagDetails;


      var currentFeedUserRelatedId = null;
      var currentFeedUserType = null;
      if (currentUser) {
        var _currentUser$feedUser = currentUser.feedUserId,
            feedUserId = _currentUser$feedUser === undefined ? {} : _currentUser$feedUser;

        currentFeedUserRelatedId = feedUserId.relatedId;
        currentFeedUserType = feedUserId.type;
      }
      var showAnyFollow = !!currentFeedUserRelatedId;

      var _tagDetails$isFetchin = tagDetails.isFetching,
          isFetching = _tagDetails$isFetchin === undefined ? false : _tagDetails$isFetchin;
      var _tagDetails$users = tagDetails.users,
          users = _tagDetails$users === undefined ? [] : _tagDetails$users;


      if (this.props.currentUserIsTagged) {
        users = users.slice();
        users.unshift(currentUser);
      }
      users = _underscore2.default.uniq(users, false, function (user) {
        return user.feedUserId.type + '-' + user.feedUserId.relatedId;
      });

      var userList = users.map(function (user) {
        return _react2.default.createElement(
          'li',
          { key: user.userId },
          _react2.default.createElement(_UserRow2.default, {
            logData: _this2.props.logData,
            onClickProfile: _this2.onClickProfile,
            showFollowButton: showAnyFollow && !(user.feedUserId.type === currentFeedUserType && user.feedUserId.relatedId === currentFeedUserRelatedId),
            user: user
          })
        );
      });

      return _react2.default.createElement(
        'div',
        {
          className: 'feed-modal-user-list-wrapper',
          onScroll: this.onScrollContent,
          ref: 'taggedUsersWrapper'
        },
        _react2.default.createElement(
          'ul',
          { className: 'feed-modal-user-list' },
          userList
        ),
        isFetching ? _react2.default.createElement(
          'div',
          { className: 'infinite-css-spinner-wrapper' + (userList && userList.length ? '' : ' full-height') },
          _react2.default.createElement('div', { className: 'infinite-css-spinner' })
        ) : null
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Uniform.Modal,
        {
          isOpen: this.props.showModal,
          title: 'Tagged In This Post',
          onAfterOpen: _pagescrollHelper.disablePageScroll,
          onClose: this.props.onCloseModal
        },
        _react2.default.createElement(
          'div',
          { className: 'feed-modal-content' },
          this.getTaggedUsersComponent()
        )
      );
    }
  }]);

  return TagDetailsModal;
}(_react.Component);

TagDetailsModal.propTypes = {
  communityContentIdObject: spt.CommunityContentId.isRequired,
  currentUserDetails: spt.ReactionUserDetails,
  currentUserIsTagged: _react.PropTypes.bool,
  logData: _react.PropTypes.object.isRequired,
  onCloseModal: _react.PropTypes.func.isRequired,
  tagDetails: _react.PropTypes.shape({
    isError: _react.PropTypes.bool,
    isFetching: _react.PropTypes.bool,
    lastTaggedUserId: _react.PropTypes.string,
    users: _react.PropTypes.arrayOf(_react.PropTypes.object)
  }).isRequired,
  showModal: _react.PropTypes.bool.isRequired,
  dispatch: _react.PropTypes.func.isRequired
};
TagDetailsModal.defaultProps = {
  currentUserDetails: null,
  currentUserIsTagged: false,
  logData: {}
};
exports.default = TagDetailsModal;